import { Tooltip, TooltipProps } from "primereact/tooltip";
import { ReactNode } from "react";
import { v4 as uuid } from "uuid";

type TooltipWrapperProps = {
  tooltipText: string;
  tooltipVisible?: boolean;
  children: ReactNode;
  tooltipProps?: TooltipProps;
};

export const TooltipWrapper: React.FC<TooltipWrapperProps> = ({
  tooltipText,
  children,
  tooltipProps,
  tooltipVisible = true,
}) => {
  const tooltipId = `tooltip-${uuid()}`;

  return (
    <>
      {tooltipVisible && <Tooltip target={`#${tooltipId}`} {...tooltipProps} />}
      <div
        data-pr-tooltip={tooltipText}
        data-pr-showdelay={500}
        id={tooltipId}
        style={{ display: "inline-block" }}
      >
        {children}
      </div>
    </>
  );
};
